import BoxText from "../Components/BoxText";
import PagesHeader from "../Components/PagesHeader";
import CardContainer from "../Containers/CardContainer";
import { BackgroundBox } from "../Styles/Background";


export const Boutique = () => {

   return (
      <BackgroundBox>
         <PagesHeader
            title={"La boutique"}
            description={"Découvrez nos vins avec nos quatre premières bouteilles disponibles à la vente. Nos différents produits dérivés signés Le Chai sauront aussi vous ravir."}
         />
         <meta name="description" content="vente de bouteilles de vin rouge, vin blanc et rosé, bio et natures"/>
         <CardContainer typeProduit={'boutique'} />
      </BackgroundBox>
   )
};

export default Boutique;